import React from "react";

const ProductSidebarWrapper = ({
  children,
  title,
  className,
  contentClassName,
  titleClassName,
  line,
  lineStyle,
}) => {
  return (
    <div
      className={`${className} text-gray-200 w-80 h-auto bg-[#222222] rounded-xl flex flex-col p-3`}
    >
      <div
        className={`${
          !line && "product-wrapper-title"
        } flex w-full items-center gap-2 py-2 relative text-gray-200 pr-2 ${titleClassName} `}
      >
        {line && (
          <span
            style={lineStyle}
            className="block w-5 h-2 bg-yellow-700 rounded-full"
          ></span>
        )}
        <div className="w-full">{title}</div>
      </div>
      {children && (
        <div className={`${contentClassName} mt-5 flex flex-col gap-3`}>
          {children}
        </div>
      )}
    </div>
  );
};

export default ProductSidebarWrapper;
